import React from 'react';
import './TenantGuide.css';

function TenantGuide() {
    return (
        <div className="tenant-guide">
            <div className="tenant-guide-container">
                <h1>Tenant Guide - Getting Started with At Home Laundromat</h1>

                <section className="guide-section">
                    <h2>1. Download the App</h2>
                    <div className="download-links">
                        <a href="https://apps.apple.com/ph/app/at-home-laundromat/id6751446875"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="download-button ios">
                            <img
                                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                                alt="Download on the App Store"
                                className="store-badge"
                            />
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.trantechus.laundromat"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="download-button android">
                            <img
                                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                                alt="Get it on Google Play"
                                className="store-badge"
                            />
                        </a>
                    </div>
                </section>

                <section className="guide-section">
                    <h2>2. Create Your Account</h2>
                    <p>Sign up for a new account using your email address or phone number.</p>
                </section>

                <section className="guide-section">
                    <h2>3. Complete Your Profile</h2>
                    <p>To complete your registration:</p>
                    <ul>
                        <li>Contact your property administrator</li>
                        <li>Request your unique property code</li>
                        <li>Provide your unit number</li>
                        <li>Enter these details in the app to finish the setup</li>
                    </ul>
                </section>

                <section className="guide-section">
                    <h2>4. Loading Your Balance</h2>
                    <p>To start using the laundry services:</p>
                    <ul>
                        <li>Contact your property administrator</li>
                        <li>Ask about available free credits for new users</li>
                        <li>Get information about balance reload options</li>
                        <li>Follow their instructions to add funds to your account</li>
                    </ul>
                </section>
            </div>
        </div>
    );
}

export default TenantGuide;